import React from 'react';

import { Icon, IconProps } from '@chakra-ui/react';

import { chakraDefaultFocusStyles } from 'theme/themeConstants';

const CloseIcon = (props: IconProps) => {
  return (
    <Icon
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill="currentColor"
      sx={{ _focus: { ...chakraDefaultFocusStyles, outline: 'none' } }}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M13.41 12l6.3-6.29a1 1 0 10-1.42-1.42L12 10.59l-6.29-6.3a1 1 0 00-1.42 1.42l6.3 6.29-6.3 6.29a1 1 0 000 1.42 1 1 0 001.42 0l6.29-6.3 6.29 6.3a1 1 0 001.42 0 1 1 0 000-1.42z"
      />
    </Icon>
  );
};

export default CloseIcon;
